var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_transactions",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transaction"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_Last_transactions",
    transform: "translate(1.636364, 0.763636)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4-Copy-8",
    fill: "#9D1131",
    transform: "translate(10.363636, 6.218182) scale(1, -1) rotate(-360.000000) translate(-10.363636, -6.218182) ",
    points: "5.68698194 -3.02283451e-14 5.68698194 4.64538898 20.7272727 4.64538898 20.7272727 8.0814746 5.68698194 8.0814746 5.68698194 12.4363636 7.79226565e-14 6.35804691"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4-Copy-8",
    fill: "#FF3F77",
    transform: "translate(10.363636, 16.581818) scale(1, -1) rotate(-180.000000) translate(-10.363636, -16.581818) ",
    points: "5.68698194 10.3636364 5.68698194 15.0090253 20.7272727 15.0090253 20.7272727 18.445111 5.68698194 18.445111 5.68698194 22.8 7.79226565e-14 16.7216833"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.1543b7311b3aff91cdf6171ca8176bdf.svg";
export { ForwardRef as ReactComponent };